import { render, staticRenderFns } from "./UploadTaskList.vue?vue&type=template&id=04789336&scoped=true&"
import script from "./UploadTaskList.vue?vue&type=script&lang=js&"
export * from "./UploadTaskList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!///node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04789336",
  null
  
)

export default component.exports